(() => {
  class Slideshow {
    constructor(element) {
      this.wrapper = element;
      this.slides = element.querySelectorAll('.slide');
      this.dots = element.querySelectorAll('.slideshow-dot');
      this.prevBtn = element.querySelector('[data-slideshow-prev]');
      this.nextBtn = element.querySelector('[data-slideshow-next]');
      this.currentSlide = 0;
      this.isAutoplay = element.getAttribute('data-autoplay') === 'true';
      this.speed = parseInt(element.getAttribute('data-speed')) * 1000 || 5000;
      this.autoplayTimer = null;
      this.isPaused = false;


      this.init();
    }

    init() {
      if (this.slides.length <= 1) return;

      this.bindEvents();
      
      // Ensure first slide is active
      if (this.slides.length > 0) {
        this.slides[0].classList.add('active');
        if (this.dots.length > 0) {
          this.dots[0].classList.add('active');
        }
      }
      
      if (this.isAutoplay) {
        // Small delay to ensure everything is rendered
        setTimeout(() => {
          this.startAutoplay();
        }, 100);
      }
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prevSlide());
      }
      
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.nextSlide());
      }

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Pause autoplay on hover
      this.wrapper.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.wrapper.addEventListener('mouseleave', () => this.resumeAutoplay());

      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (this.wrapper.closest('.media-banner-section:hover')) {
          if (e.key === 'ArrowLeft') this.prevSlide();
          if (e.key === 'ArrowRight') this.nextSlide();
        }
      });

      // Touch/swipe support
      let touchStartX = 0;
      let touchEndX = 0;

      this.wrapper.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      });

      this.wrapper.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe(touchStartX, touchEndX);
      });
    }

    handleSwipe(startX, endX) {
      const swipeThreshold = 50;
      const diff = startX - endX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }
    }

    goToSlide(index) {
      if (index === this.currentSlide) return;

      // Remove active class from current slide
      this.slides[this.currentSlide].classList.remove('active');
      this.dots[this.currentSlide]?.classList.remove('active');

      this.currentSlide = index;

      // Add active class to new slide
      this.slides[this.currentSlide].classList.add('active');
      this.dots[this.currentSlide]?.classList.add('active');


      this.resetAutoplay();
    }

    nextSlide() {
      const nextIndex = (this.currentSlide + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    prevSlide() {
      const prevIndex = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }

    startAutoplay() {
      if (!this.isAutoplay || this.slides.length <= 1) return;
      
      this.autoplayTimer = setInterval(() => {
        if (!this.isPaused) {
          this.nextSlide();
        }
      }, this.speed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    pauseAutoplay() {
      this.isPaused = true;
    }

    resumeAutoplay() {
      this.isPaused = false;
    }

    resetAutoplay() {
      if (this.isAutoplay) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    destroy() {
      this.stopAutoplay();
      // Remove event listeners would go here if needed
    }
  }

  // Collections hover effect (preserve existing functionality)
  let handleCollections = (container) => {
    const collectionsItems = container.querySelectorAll('.media-banner__collections-item');
    
    collectionsItems.forEach((item) => {
      item.addEventListener('mouseover', () => {
        collectionsItems.forEach((otherItem) => {
          otherItem.classList.add('media-banner__collections-item--opacity');
        });
        item.classList.remove('media-banner__collections-item--opacity');
        
        item.addEventListener('mouseout', () => {
          collectionsItems.forEach((otherItem) => {
            otherItem.classList.remove('media-banner__collections-item--opacity');
          });
        });
      });
    });
  };

  // Marquee functionality (preserve existing functionality)
  let handleMarquee = (container) => {
    const marquee = container.querySelector('.banner__marquee');
    if (!marquee) return;

    const speed = 575 < document.documentElement.clientWidth
      ? 7000 * marquee.getAttribute('data-ticker-speed')
      : 3000 * marquee.getAttribute('data-ticker-speed');

    if (!marquee.querySelector('.js-marquee-wrapper')) {
      marquee.classList.add('marquee');
      const $marquee = $(marquee);
      
      $marquee.marquee({
        delayBeforeStart: 0,
        direction: 'left',
        allowCss3Support: true,
        startVisible: true,
        duration: speed,
        gap: 0,
      });

      if (container && container.nodeType === Node.ELEMENT_NODE) {
        new ResizeObserver(() => {
          $marquee.marquee('destroy');
          $marquee.marquee({
            delayBeforeStart: 0,
            direction: 'left',
            allowCss3Support: true,
            startVisible: true,
            duration: speed,
            gap: 0,
          });
        }).observe(container);
      }
    }
  };

  // Initialize slideshow and existing functionality
  let init = (container = document) => {
    // Initialize slideshows
    const slideshows = container.querySelectorAll('[data-slideshow]');
    slideshows.forEach(slideshow => {
      new Slideshow(slideshow);
    });

    // Initialize existing functionality
    handleCollections(container);
    handleMarquee(container);
  };

  // Initialize on load and section reload
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();